import {
  all,
  call,
  cancel,
  debounce,
  delay,
  fork,
  join,
  put,
  race,
  take,
  takeLatest,
} from "redux-saga/effects"

import { updateOrderValues } from "./actions"
import doJavaScriptTracking from "./sagas/do-javascript-tracking"
import doLogin from "./sagas/do-login"
import handleFormikChange from "./sagas/handle-formik-change"
import loadDeliveryMethods from "./sagas/load-delivery-methods"
import redeemPoints from "./sagas/redeem-points"
import submitOrder from "./sagas/submit-order"
import updateCheckout from "./sagas/update-checkout"
import updateUserData from "./sagas/update-user-data"
import validatePanels from "./sagas/validate-panels"

let soloTask = false
let latestOrderValueAction = null
let updateOrderTask = null

function* applyAdjustment(action) {
  if (updateOrderTask) {
    yield cancel(updateOrderTask)
  }
  if (!soloTask) {
    soloTask = true
    if (latestOrderValueAction) {
      yield put(
        updateOrderValues(
          latestOrderValueAction.props,
          latestOrderValueAction.setFieldValue,
          latestOrderValueAction.endpoint
        )
      )
    }
    yield call(updateCheckout, action)
    soloTask = false
    if (action.type === "APPLY_GIFT_CARD" && action.setFieldValue) {
      action.setFieldValue("gift_code", "")
    }
  }
}

// This is a modified delay effect
// Modified portion includes the tracking of latestOrderValueAction
// and the invocation of yield put once debounced is true
// @see https://redux-saga.js.org/docs/api/
const debounceOrderValues = (ms, pattern) =>
  fork(function* () {
    while (true) {
      let action = yield take(pattern)
      latestOrderValueAction = action

      while (true) {
        const { debounced, latestAction } = yield race({
          debounced: delay(ms),
          latestAction: take(pattern),
        })

        if (debounced) {
          yield put(
            updateOrderValues(
              action.props,
              action.setFieldValue,
              action.endpoint
            )
          )
          break
        }

        action = latestAction
        latestOrderValueAction = action
      }
    }
  })

// const takeLatestDelivery = (patternOrChannel, saga, ...args) =>
//   fork(function* () {
//     let deliveryTask
//     while (true) {
//       const action = yield take(patternOrChannel)
//       // By checking the data.shipping_updated flag here, we avoid cancelling
//       // other loadDeliveryMethod sagas that were actually populating the
//       // delivery methods
//       if (action.data.shipping_updated) {
//         if (deliveryTask) {
//           yield cancel(deliveryTask)
//         }
//         deliveryTask = yield fork(saga, ...args.concat(action))
//       } else {
//         // Check if Apple/Google Pay Interface waiting for update
//         if (window && window.jewlrAppleGooglePay) {
//           window.jewlrAppleGooglePay.CallbackController()
//         }
//       }
//     }
//   })

function* triggerSubmitOrder(action) {
  soloTask = true
  // Wait for the update checkout saga to finish before running submit
  try {
    if (updateOrderTask && updateOrderTask.isRunning()) {
      yield join(updateOrderTask)
    }
  } finally {
    // The finally ensures that submitOrder is always run, even if the updateOrderTask
    // propagates a cancellation up into this saga
    yield call(submitOrder, action)
    soloTask = false
  }
}

function* forkUpdateOrder(action) {
  if (!soloTask) {
    if (updateOrderTask) {
      yield cancel(updateOrderTask)
    }
    updateOrderTask = yield fork(updateCheckout, action)
  }
}

function* orderCompleted() {
  // eslint-disable-next-line no-undef
  yield call(Cookies.remove, sl.config.cookies_config.cart_token)
}

function* rootSaga() {
  yield all([
    takeLatest(
      ["LOAD_ORDER_DATA", "PRELOAD_ORDER_DATA", "SET_PAYMENT_METHOD"],
      validatePanels
    ),
    takeLatest("SET_USER_ON_CHECKOUT_LOGIN", validatePanels),
    takeLatest("SUBMIT_ORDER", triggerSubmitOrder),
    takeLatest("USER_LOGIN", doLogin),

    debounceOrderValues(400, "DEBOUNCE_ORDER_VALUES"),
    debounce(1000, "UPDATE_ORDER_VALUES", forkUpdateOrder),
    takeLatest("UPDATE_ORDER_VALUES_NOW", updateCheckout),
    takeLatest("HANDLE_FORMIK_CHANGE", handleFormikChange),
    takeLatest(
      ["APPLY_GIFT_CARD", "CHECK_GIFT_CARD", "REMOVE_GIFT_CARD"],
      applyAdjustment
    ),
    takeLatest("REDEEM_REWARDS", redeemPoints),
    takeLatest("REMOVE_REWARDS", redeemPoints),
    takeLatest("DO_JAVASCRIPT_TRACKING", doJavaScriptTracking),
    takeLatest("ORDER_COMPLETED", orderCompleted),
    takeLatest("UPDATE_USER_DATA", updateUserData),
    takeLatest("VALIDATE_PANELS", validatePanels),
    takeLatest("LOAD_DELIVERY_METHODS", loadDeliveryMethods),
  ])
}

export default rootSaga
